import {AfterViewInit, Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {MustMatch} from '../enter-passcode/enter-passcode.component';
import {GlobalEventsManager} from '../../GlobalEventManager';

@Component({
  selector: 'app-account-profile',
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.css']
})
export class AccountProfileComponent implements OnInit, AfterViewInit {
  myForm: UntypedFormGroup;
  myForm2: UntypedFormGroup;
  submitted = false;
  navisErrors: string;
  clientRequest: ClientRequest;
  myUser = {} as User;


  subscription: Subscription;
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  phone: string = "";
  maherError: string = "";
  activePass: boolean = true;
  activeNewPass: boolean = true;
  passFields: boolean = true;
  badPassword: boolean = false;
  disableSubmit: boolean = true;
  activeNewConfirm: boolean = true;
  activeConfirm: boolean = true;
  showAccountProfile:boolean = false;
  showAccountPassword:boolean = false;
  numberFound: number;
  totalFound: number;
  lowerFound: number;
  strangeFound: number;
  phoneApp: boolean = false;
  ipadApp: boolean = false;

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent,private  globalEventsManager: GlobalEventsManager) {
    this.myForm = fb.group({
      username:   ['',[]],
      password:   ['',[]],
      confirm:   ['',  []],
      firstName:  ['',  [Validators.pattern( '^[a-zA-Z]+$'), Validators.required]],
      sealink:  ['',  [Validators.pattern( '^[0-9]+$'), Validators.required]],
      lastName:   ['',  [Validators.pattern( '^[\\.a-zA-Z\\s-]+$'), Validators.required]],
      phone:      ['',[Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/),Validators.required]],
      fax:      ['',[Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
      email: ['', [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'), Validators.required]],
    });


    this.myForm2 = fb.group({
        actualPassword:   ['',[]],
        newPassword:   [{value: '', disabled: this.passFields},  []],
        newConfirm:   [{value: '', disabled: this.passFields},  []],
        oldPassword: ['', []]
    });

    this.myUser = this.myApp.user;

    /*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
    //this.myUser.company_code ="EGN"
    this.myUser.company_code ="M0995"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= "cc@dom.com"
    this.myUser.fax_number= "9082373221"
    this.myUser.first_name= "Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= null;
    this.myUser.phone_number= "908338922"
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "8237887"
     this.myUser.role= "MISC"
    //this.myUser.role= "LINEOP"
    //this.myUser.role= "HAULIER"
    this.myUser.username="CSPDRIVER"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "0";




     */


  }


  checkConfirmationPassword(){
    if (this.myForm2.controls["newPassword"].value==this.myForm2.controls["newConfirm"].value){
      this.disableSubmit = false;
    }else{
      this.disableSubmit = true;
    }

    }



  checkRules(){
    var character='';
    var i=0;

    this.totalFound = 0;
    this.lowerFound = 0;
    this.numberFound = 0;
    this.strangeFound = 0;

    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    while (i <= this.myForm2.controls["newPassword"].value.length){
      character = this.myForm2.controls["newPassword"].value.charAt(i);
      if (character==""){
      }else if (!isNaN(Number(character))){
        this.numberFound = this.numberFound + 1;
      }else if( character.match(format) ){
        this.strangeFound = this.strangeFound + 1;
      }else if (character == character.toLowerCase()){
        this.lowerFound = this.lowerFound + 1;
      }
      this.totalFound = this.totalFound + 1;
      i++;
    }

  }


  showProfile(){
    this.showAccountProfile = true;
    this.myForm.reset(true);
    this.myForm.controls["username"].setValue(this.myUser.username);
    this.myForm.controls["email"].setValue(this.myUser.email_address);
    this.myForm.controls["firstName"].setValue(this.myUser.first_name);
    this.myForm.controls["lastName"].setValue(this.myUser.last_name);
    this.myForm.controls["phone"].setValue(this.myUser.phone_number);
    if (this.myUser.role=="MISC"){
      this.myForm.controls["sealink"].setValue(this.myUser.sealink);
    }

    this.myForm.controls["fax"].setValue(this.myUser.fax_number);
    this.myForm2.controls["actualPassword"].setValue(this.myUser.password);
  }
  showPasswordPage(){
    this.showAccountPassword = true;
    this.numberFound = 0;
    this.strangeFound = 0;
    this.totalFound = 0;
    this.lowerFound = 0;
    this.passFields = true;
    this.disableSubmit = true;
    this.submitted = false;
    this.myForm2.reset(true);
    this.myForm2.controls["newPassword"].disable();
    this.myForm2.controls["newPassword"].setValue("");
    this.myForm2.controls["newConfirm"].disable();
    this.myForm2.controls["newConfirm"].setValue("");
    this.myForm2.controls["oldPassword"].setValue("");
  }

  returnToChoice(){
    this.showAccountPassword = false;
    this.showAccountProfile = false;
  }

  showNewPassword(){
    if (this.activeNewPass){
      this.activeNewPass = false;
    }else{
      this.activeNewPass = true;
    }
  }

  showConfirmPassword(){
    if (this.activeConfirm){
      this.activeConfirm = false;
    }else{
      this.activeConfirm = true;
    }
  }


  showPassword(){
    if (this.activePass){
      this.activePass = false;
    }else{
      this.activePass = true;
    }
  }

  get f() { return this.myForm.controls;}

  ngOnInit() {
    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }

  }

  createUpdateNewUser(modeIn: string){
    this.submitted = true;

    this.navisErrors = "";
    if (modeIn=="P") {
          if (!this.myForm2.valid) {
            return;
          }
          if (this.numberFound< 1 || this.totalFound < 5 || this.lowerFound < 3 || this.strangeFound < 1){
            return;
          }
          this.checkConfirmationPassword();
          if (this.disableSubmit){
            return;
          }
    } else {
          if (!this.myForm.valid) {
            return;
          }
    }


      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.myUser.maherError = null;
      if (modeIn == "P") {
        this.myUser.password = this.myForm2.controls["newPassword"].value;
      } else {
        this.myUser.first_name = this.myForm.controls.firstName.value;
        this.myUser.last_name = this.myForm.controls.lastName.value;
        this.myUser.phone_number = this.myForm.controls.phone.value;
        if (this.myForm.controls.fax.value != "") {
          this.myUser.fax_number = this.myForm.controls.fax.value;
        }
        if (this.myForm.controls.sealink.value != "") {
          this.myUser.sealink = this.myForm.controls.sealink.value;
        }else{
          this.myUser.sealink = "";
        }
        this.myUser.email_address = this.myForm.controls.email.value;
      }


      this.clientRequest.requestData = [];
      this.clientRequest.user = this.myUser;

      const lhsUserObs$ = this.queryService.accountProfileUpdateUser(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.myUser = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);

          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.submitted = false;
          if (this.myUser.maherError != null) {
              this.maherError = this.myUser.maherError;
          } else if (this.myUser.navisErrors != null) {
            for (var xx of this.myUser.navisErrors) {
              this.navisErrors = this.navisErrors + xx.valueOf();
            }
          } else {
            this.showAccountProfile = false;
            this.showAccountPassword = false;
            this.myApp.showSuccessBanner("", "the new password has been saved successfully", "profile");
          }

        });


  }


  getAdminUser(){
    const lhsUserObs$ = this.queryService.getAdminUser(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.myUser = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.myUser.maherError == null) {
          this.firstName = this.myUser.first_name;
          this.lastName = this.myUser.last_name;
          this.phone = this.myUser.phone_number;
          this.email = this.myUser.email_address;
        }

      });

  }


  checkOldPassword(){
    this.myUser.password = this.myForm2.controls["oldPassword"].value;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.requestData = [];
    this.clientRequest.user = this.myUser;


    const lhsUserObs$ = this.queryService.profileCheckPassword(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.myUser = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.myUser.maherError == null) {
          this.passFields = false;
          this.badPassword = false;
          this.myForm2.controls["newPassword"].enable();
          this.myForm2.controls["newConfirm"].enable();
        }else{
          this.passFields = true;
          this.badPassword = true;

          this.myForm2.controls["newPassword"].disable();
          this.myForm2.controls["newConfirm"].disable();
        }

      });

  }


  returnBack(){
    this.router.navigate([""]);

  }

  ngAfterViewInit(): void {
    if (this.myUser.role=="MISC"){
      this.myForm.controls["sealink"].setValidators([Validators.pattern( '^[0-9]+$'), Validators.required]);
    }else{
      this.myForm.controls['sealink'].clearValidators();
    }
    this.myForm.controls['sealink'].updateValueAndValidity();
  }
}
